import React from 'react';
import SalovareLoader from '../common/SalovareLoader';

const CustomerPageLoading = () => (
  <SalovareLoader size="medium" center sx={{ py: 8 }} />
);

export default CustomerPageLoading;
